<div id="outer" class="well container">
    @if (loading) {
        <div class="loading"></div>
    }
    <div class="col-md-12">
        <div class="well-notify"></div>
    </div>
    <div class="well-title">
        <div class="col-md-12">Logs</div>
    </div>
    <div class="col-md-12 well-content">
        <div style="display: flex; gap: 8px; align-items: center; margin-bottom: 16px">
            <nz-select [(ngModel)]="searchField" style="width: 140px">
                @for (field of searchFields; track field.value) {
                    <nz-option [nzValue]="field.value" [nzLabel]="field.label"></nz-option>
                }
            </nz-select>
            <input
                nz-input
                [(ngModel)]="searchValue"
                placeholder="Search logs..."
                style="width: 240px"
                (keydown.enter)="onSearch()" />
            <button nz-button nzType="primary" (click)="onSearch()">Search</button>
            <button nz-button (click)="clearSearch()">Reset</button>
        </div>
        <nz-table
            #logTable
            [nzData]="logs.Data"
            nzShowSizeChanger
            nzTableLayout="fixed"
            nzBordered="true"
            [nzFrontPagination]="false"
            [nzLoading]="loading"
            [nzTotal]="total"
            [nzShowTotal]="totalTemplate"
            [nzPageSize]="pageSize"
            [nzPageSizeOptions]="pageSizeOptions"
            [nzPageIndex]="pageIndex"
            (nzQueryParams)="onQueryParamsChange($event)">
            <thead style="border: 1px solid black">
                <tr>
                    <th nzWidth="40px"></th>
                    @for (column of columns; track column.title) {
                        <th
                            [nzSortFn]="column.fieldName !== null ? true : null"
                            [nzColumnKey]="column.fieldName"
                            [nzWidth]="column.width !== null ? column.width : 'auto'"
                            [nzSortOrder]="getSortOrder(column.fieldName)">
                            {{ column.title }}
                        </th>
                    }
                </tr>
            </thead>
            <tbody>
                @for (data of logs.Data; track data.ID) {
                    <tr>
                        <td style="text-align: center">
                            @if (data.Exception) {
                                <span
                                    class="fa-solid fa-triangle-exclamation"
                                    style="color: #cf1322; cursor: pointer"
                                    nz-tooltip
                                    nzTooltipTitle="Show error detail"
                                    (click)="onExpandChange(data.ID, !expandSet.has(data.ID))"></span>
                            }
                        </td>
                        <td
                            class="scrollable-cell"
                            nz-tooltip
                            [nzTooltipTitle]="data.Date | date: 'MMM d, y, h:mm:ss a'">
                            {{ data.Date | date: "MMM d, y, h:mm:ss a" }}
                        </td>
                        <td>{{ data.Level }}</td>
                        <td class="scrollable-cell" nz-tooltip [nzTooltipTitle]="data.Logger">{{ data.Logger }}</td>
                        <td class="scrollable-cell" nz-tooltip [nzTooltipTitle]="data.Message">{{ data.Message }}</td>
                        <td class="scrollable-cell">{{ data.Hostname }}</td>
                    </tr>
                    @if (!!data.Exception && expandSet.has(data.ID)) {
                        <tr [nzExpand]="expandSet.has(data.ID)">
                            <td></td>
                            <td [attr.colspan]="columns.length">
                                <pre style="margin: 0; white-space: pre-wrap; word-break: break-word">{{
                                    data.Exception
                                }}</pre>
                            </td>
                        </tr>
                    }
                }
            </tbody>
        </nz-table>
        <ng-template #totalTemplate let-total>
            Showing items {{ pageIndex * pageSize - pageSize + 1 }}–{{
                pageIndex * pageSize > total ? total : pageIndex * pageSize
            }}
            out of {{ total }}
        </ng-template>
    </div>
</div>
